import React from 'react';

import SocialStudiesSubjectPage from '../containers/SocialStudiesSubjectPage';

const SocialStudiesSubjectPageApp = (props) => (
  <SocialStudiesSubjectPage {...props} />
);

export default SocialStudiesSubjectPageApp
